import React, { useContext } from 'react'
import PropTypes from 'prop-types'

import {
  DashboardModule, Form,
} from '@domain-group/suit-theme'

import PageContext from '@contexts/pageContext'

import ToggleListItem from '@components/ToggleListItem'

const OrderBundleSettings = (props) => {
  const { orderBundlePayload, orderBundleFormPayload } = props

  const {
    callbacks: { updateOrderBundle: updateFn },
  } = orderBundlePayload

  const pageContext = useContext(PageContext)
  const {
    callbacks: { updateOrderBundle },
  } = pageContext

  const {
    entityState: {
      global,
      id,
    },
  } = orderBundleFormPayload

  const updateOrderBundlePayload = {
    callbacks: {
      action: updateFn,
    },
    entityParams: { id, global: !global },
    toastText: 'Order Bundle Updated',
  }

  return (
    <DashboardModule title="Bundle Settings">
      <Form padding="large" boxProps={{ paddingBottom: 'medium' }}>
        <ToggleListItem
          onClick={() => updateOrderBundle(updateOrderBundlePayload)}
          toggleOnText="Yes"
          toggleOffText="No"
          toggleValue={global}
        >
          <ToggleListItem.Title>Global</ToggleListItem.Title>
          <ToggleListItem.Description>
            Agencies won&apos;t be able to share within brand group.
          </ToggleListItem.Description>
        </ToggleListItem>
      </Form>
    </DashboardModule>
  )
}

OrderBundleSettings.propTypes = {
  orderBundleFormPayload: PropTypes.object.isRequired,
  orderBundlePayload: PropTypes.object.isRequired,
}

export default OrderBundleSettings
